ACC.fcoOrder = {
  bindAll: function() {
    ACC.fcoOrder.validateForm();
  },
  validateForm: function() {
    var fcoSingleclick = true;

    $('.ph-orderbtn').on('click', function(e) {
      e.stopImmediatePropagation();

      var errorField = $(this).closest('.ph-proceed2cart').find('.ph-norowerror'),
          isValid = true,
          rowCount = $('.ph-fcoitemrow input[type="checkbox"]:checked').length;

      if (rowCount === 0) {
        errorField.removeClass('hidden');
      } else {
        $('.ph-norowerror').addClass('hidden');
        $('.ph-fcoitemrow').each(function() {
          var $checkbox = $(this).find('input[type="checkbox"]'),
              $qtyParent = $(this).find('.ph-material_quantity'),
              $quantity = $qtyParent.find('.ph-fcoquantityinput'),
              $maxQuantity = $quantity.attr('data-maxQuantity');

          if ($checkbox.is(':checked') && ($quantity.val() === '' || ACC.validation.numeric($.trim($($quantity).val())))) {
            $qtyParent.addClass('ph-invalidproductdiv');
            $qtyParent.find('.mandatory-error').removeClass('hidden');
            $qtyParent.find('.max-error').addClass('hidden');
          } else if ($checkbox.is(':checked') && $quantity.val() > Number($maxQuantity)) {
            $qtyParent.addClass('ph-invalidproductdiv');
            $qtyParent.find('.max-error').removeClass('hidden');
            $qtyParent.find('.mandatory-error').addClass('hidden');
          } else {
            $qtyParent.removeClass('ph-invalidproductdiv');
            $qtyParent.find('.mandatory-error,.max-error').addClass('hidden');
          }
        });

        if ($('.ph-invalidproductdiv').length > 0) {
          isValid = false;
        }

        if (isValid && fcoSingleclick) {
          fcoSingleclick = false;
          $('.ph-ordersub').click();
        }
      }
    });
    $('#fcoCheck_top').on('click', function() {
      if ($(this).is(':checked')) {
        $('.ph-fcocheckbox, #fcoCheck_bottom').prop('checked', true).trigger('change');
      } else {
        $('.ph-fcocheckbox, #fcoCheck_bottom').prop('checked', false).trigger('change');
      }
    });
    $('#fcoCheck_bottom').on('click', function() {
      if ($(this).is(':checked')) {
        $('.ph-fcocheckbox, #fcoCheck_top').prop('checked', true).trigger('change');
      } else {
        $('.ph-fcocheckbox, #fcoCheck_top').prop('checked', false).trigger('change');
      }
    });
    $('.ph-fcocheckbox').on('change', function() {
      var checckboxLength = $('.ph-fcocheckbox').length,
          checckedLength = $('.ph-fcocheckbox:checked').length;

      if ($(this).is(':checked')) {
        $(this).val('true');
      } else {
        $(this).val('false');
      }

      if (checckboxLength === checckedLength) {
        $('#fcoCheck_top, #fcoCheck_bottom').prop('checked', true);
      } else {
        $('#fcoCheck_top, #fcoCheck_bottom').prop('checked', false);
      }
    });
  },
  initCheck: function() {
    var rowCount = $('.ph-fcoitemrow').length;

    $('.ph-nodataerror').addClass('hidden');

    if (rowCount === 0) {
      $('.ph-header_footer').addClass('hidden').removeClass('ph-d-flex');
      $('.ph-nodataerror').removeClass('hidden');
    } else if (rowCount < 11) {
      $('.ph-fcoformheader').addClass('hidden').removeClass('ph-d-flex');
    } else {
      $('.ph-header_footer').addClass('ph-d-flex').removeClass('hidden');
    }
  }
};
$(document).ready(function() {
  ACC.fcoOrder.bindAll();
});
$(window).on('load', function() {
  ACC.fcoOrder.initCheck();
});
